import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { ASSETS } from '../data/villaData';

export default function VillaLayout() {
  const { t } = useLanguage();

  const sections = [
    { key: 'living', images: [ASSETS.living], reverse: false },
    { key: 'beds', images: [ASSETS.bedroom, ASSETS.bathroom], reverse: true },
    { key: 'kitchen', images: [ASSETS.kitchen], reverse: false },
    { key: 'outdoor', images: [ASSETS.gardenLife, ASSETS.poolAerial], reverse: true }
  ];

  return (
    <section id="villa" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-sm tracking-[0.3em] uppercase text-[#b8945e] font-medium mb-4">{t.layout.eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900">{t.layout.title}</h2>
          <div className="w-20 h-px bg-[#b8945e] mx-auto mt-6" />
        </div>

        <div className="space-y-24">
          {sections.map((s, i) => (
            <div key={s.key} className={`grid lg:grid-cols-2 gap-12 items-center ${s.reverse ? 'lg:grid-flow-dense' : ''}`}>
              <div className={s.reverse ? 'lg:col-start-2' : ''}>
                {s.images.length === 1 ? (
                  <div className="relative group">
                    <div className="aspect-[4/3] overflow-hidden rounded-3xl shadow-2xl">
                      <img src={s.images[0]} alt={t.layout[s.key].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                    <div className="absolute -bottom-4 -right-4 bg-[#b8945e] text-white px-6 py-3 rounded-2xl font-serif text-xl shadow-xl">
                      0{i + 1}
                    </div>
                  </div>
                ) : (
                  <div className="relative">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="aspect-[3/4] overflow-hidden rounded-2xl shadow-xl mt-8">
                        <img src={s.images[0]} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                      </div>
                      <div className="aspect-[3/4] overflow-hidden rounded-2xl shadow-xl">
                        <img src={s.images[1]} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                      </div>
                    </div>
                    <div className="absolute -bottom-4 -right-4 bg-[#b8945e] text-white px-6 py-3 rounded-2xl font-serif text-xl shadow-xl">
                      0{i + 1}
                    </div>
                  </div>
                )}
              </div>
              <div className={s.reverse ? 'lg:col-start-1 lg:row-start-1' : ''}>
                <h3 className="font-serif text-3xl md:text-4xl text-stone-900 mb-5">{t.layout[s.key].title}</h3>
                <div className="w-12 h-px bg-[#b8945e] mb-6" />
                <p className="text-stone-700 leading-relaxed text-lg">{t.layout[s.key].text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
